import { render, staticRenderFns } from "./ppreparedialogue.vue?vue&type=template&id=d65e63d0&scoped=true&"
import script from "./ppreparedialogue.vue?vue&type=script&lang=js&"
export * from "./ppreparedialogue.vue?vue&type=script&lang=js&"
import style0 from "./ppreparedialogue.vue?vue&type=style&index=0&id=d65e63d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65e63d0",
  null
  
)

export default component.exports